import { Component, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';

import { selectMessagesForOpenedEditorForProperty } from 'src/app/project/store/project-data/project-data.selectors';
import type { TreeEntity } from '../../../core/models/entity.model';
import { EntityPropertyBaseComponent } from '../entity-property-base/entity-property-base.component';
import type { FormControlOptions } from '@angular/forms';

@Component({
  selector: 'app-entity-property-checkbox',
  templateUrl: './entity-property-checkbox.component.html',
  styleUrls: ['./entity-property-checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class EntityPropertyCheckboxComponent extends EntityPropertyBaseComponent<boolean> implements OnChanges {
  messages: TreeEntity[] = [];

  messagesForOpenedEditorForProperty$ = (key: string) => this.store.select(selectMessagesForOpenedEditorForProperty(key, this.entityId));

  constructor(private store: Store) {
    super();
    this.messagesForOpenedEditorForProperty$ = (propertyKey: string) =>
      this.store.select(selectMessagesForOpenedEditorForProperty(this.property.Key, this.entityId)).pipe(take(1));
  }

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    if (changes['property']) {
      this.messagesForOpenedEditorForProperty$(this.property.Key)
        .pipe(take(1))
        .subscribe(msgs => (this.messages = msgs));
    }
  }

  override getFormControlOptions(): FormControlOptions {
    return { updateOn: 'change' };
  }
}
